import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import { getApiURL } from '../../constants';
import { IColors, IPersonItem } from '../../interfaces/Conference';
import {
    CloseButton,
    Description,
    Footer,
    Header,
    Icon,
    Image,
    Label,
    LabelPosition,
    Link,
    Modal,
    ModalContent,
    Name,
    Social,
    Wrapper,
} from './ConferenceLecturer.elements';

interface ConferenceProps {
    onClose: () => void;
    colors?: IColors;
    person?: IPersonItem;
}

const ConferenceLecturerTemplate: FC<ConferenceProps> = ({ onClose, colors, person }) => {
    const { t } = useTranslations();
    return (
        <Wrapper>
            <Modal>
                <ModalContent>
                    <CloseButton onClick={onClose}>
                        <Icon name={Icons.Xmark} colors={colors} />
                    </CloseButton>
                    <Header>
                        {person.photo && <Image src={`${getApiURL()}/media/people/${person?.photo}`} />}
                        {!person.photo && <Image src="/public/avatar.svg" />}

                        <Name colors={colors}>
                            {person?.titles?.before_name &&
                                `${person?.titles?.before_name} `
                            }
                            {person.name} {person.surname}
                            {person?.titles?.after_name &&
                                `, ${person?.titles?.after_name}`
                            }
                        </Name>
                        {person?.position && (
                            <LabelPosition>{person.position}</LabelPosition>
                        )}
                        {person?.company && (
                            <Label>{person.company}</Label>
                        )}
                    </Header>
                    <Description dangerouslySetInnerHTML={{ __html: person?.annotation }}></Description>
                    <Footer>
                        <Social>
                            {person.links?.facebook && (
                                <Link href={person.links?.facebook} target="_blank" colors={colors}>
                                    <Icon name={Icons.Facebook} colors={colors} />
                                </Link>
                            )}

                            {person.links?.linkedin && (
                                <Link href={person.links?.linkedin} target="_blank" colors={colors}>
                                    <Icon name={Icons.Linkedin} colors={colors} />
                                </Link>
                            )}

                            {person.links?.instagram && (
                                <Link href={person.links?.instagram} target="_blank" colors={colors}>
                                    <Icon name={Icons.Instagram} colors={colors} />
                                </Link>
                            )}

                            {person.links?.twitter && (
                                <Link href={person.links?.twitter} target="_blank" colors={colors}>
                                    <Icon name={Icons.Twitter} colors={colors} />
                                </Link>
                            )}

                            {person.links?.web && (
                                <Link href={person.links?.web} target="_blank" colors={colors}>
                                    <Icon name={Icons.Laptop} colors={colors} />
                                </Link>
                            )}
                        </Social>
                    </Footer>
                </ModalContent>
            </Modal>
        </Wrapper>
    );
};

export default ConferenceLecturerTemplate;
